import React from 'react'
import { ChartCard } from './AIChartParts'
import AIHorizontalBars from './AIHorizontalBars'
import { SERIES } from './aiCostFormat'

const TOP = 10

const AIFeatureBreakdown = ({ features = [], isLoading, error }) => (
  <ChartCard
    title="Cost by Feature"
    subtitle={features.length > TOP ? `Top ${TOP} of ${features.length}` : null}
    isLoading={isLoading}
    error={error}
    isEmpty={!features.length}
  >
    <AIHorizontalBars
      rows={features.slice(0, TOP).map((f) => ({
        label: f.feature || 'general',
        cost: f.cost,
        requests: f.requests,
        color: SERIES.blue,
      }))}
    />
  </ChartCard>
)

export default AIFeatureBreakdown
